// @flow

import axios from 'axios';
import { getFlowBaseUrl } from '../config/config';

export default function getFlowDetail(payload: Object): Promise<Object> {
  return axios.get(`${getFlowBaseUrl()}projects/${payload.projectId}/workflows/${payload.workflowID}`, { withCredentials: true });
}
